import React, {Component} from 'react';
import {BarLoader} from 'react-spinners';
import './Loader.css';
import FmImage from '../img/flitsmeister_app_icon.png';
import TouringImage from '../img/icon-touring.png';

class Loader extends Component {
    render() {
        let loadingIcon;

        switch (this.props.host) {
            case "flitsmeister":
                loadingIcon = FmImage;
                break;
            case "touring":
                loadingIcon = TouringImage;
                break;
            default:
                loadingIcon = FmImage;
                break;
        }

            return (
            <div className="loader-background">
                <div className="loader">
                    <div className="fm-logo-loader">
                        <img src={loadingIcon} alt="Loading"/>
                    </div>
                    <BarLoader color={this.props.themeColor}/>
                </div>
            </div>
        )
    }
}

export default Loader;
